<template>
  <div class="table table--hero slicing-profiles">
    <b-table :fields="fields" :items="profilesList" primary-key="id">
      <template v-slot:cell(actions)="data">
        <slicing-profile-delete-button :profile-id="data.item.id"
                                       :profile-name="data.item.name" 
                                       :confirm-message="$t('profiles.confirmDeleteDefaultProfile')"></slicing-profile-delete-button>
      </template>
    </b-table>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";

  import ApplicationMixin from "@/mixins/application";
  import SlicingProfileDeleteButton from "./SlicingProfileDeleteButton";

  export default {
    name: 'slicing-profiles-default-table',
    components: {SlicingProfileDeleteButton},
    mixins: [ApplicationMixin],
    data() {
      return {
        fields: [
          {key: 'name', class: 'name'},
          {key: 'printer_type', class: 'printer'},
          {key: 'actions', class: 'actions'}
        ]
      }
    },
    computed: {
      ...mapGetters(['getProfiles']),

      profilesList() {
        return this.getProfiles.filter(profile => {
          return profile.deleted_by === null && profile.is_default === 't';
        });
      }
    },
      }
</script>
